import { SocialOverviewFieldProp } from '@/componentsV2/organisms/SocialRewards/CampaignOverview.vue';
import { SOCIAL_PROFILE_NAMES } from '@/utils/socialLinks';

export enum ESocialRewards {
  FACEBOOK_SHARE = 'facebook-share',
  FACEBOOK_LIKE = 'facebook-like',
  INSTAGRAM_FOLLOW = 'instagram-follow',
  TWITTER_FOLLOW = 'twitter-follow',
  TWITTER_SHARE = 'twitter-share',
  YOUTUBE_SUBSCRIBE = 'youtube-subscribe',
  TIKTOK_FOLLOW = 'tiktok-follow',
  PINTEREST_FOLLOW = 'pinterest-follow'
}

export const socialProfilesDictionary = {
  [ESocialRewards.FACEBOOK_SHARE]: SOCIAL_PROFILE_NAMES.WEB_SITE,
  [ESocialRewards.TWITTER_SHARE]: SOCIAL_PROFILE_NAMES.WEB_SITE,
  [ESocialRewards.FACEBOOK_LIKE]: SOCIAL_PROFILE_NAMES.FACEBOOK,
  [ESocialRewards.INSTAGRAM_FOLLOW]: SOCIAL_PROFILE_NAMES.INSTAGRAM,
  [ESocialRewards.TWITTER_FOLLOW]: SOCIAL_PROFILE_NAMES.TWITTER,
  [ESocialRewards.YOUTUBE_SUBSCRIBE]: SOCIAL_PROFILE_NAMES.YOUTUBE,
  [ESocialRewards.TIKTOK_FOLLOW]: SOCIAL_PROFILE_NAMES.TIKTOK,
  [ESocialRewards.PINTEREST_FOLLOW]: SOCIAL_PROFILE_NAMES.PINTEREST
};

export type SocialRewardCreateDataType = {
  pageTitle: string;
  labelName?: string;
  campaignSettings: {
    icon: string;
    title: string;
    inputProps: {
      label: string;
      placeholder: string;
    };
    showExtraInput?: boolean;
    extraInputProps?: {
      label: string;
      placeholder: string;
    };
  };
  campaignOverview: {
    title: string;
    description: string;
    fields: SocialOverviewFieldProp[];
    icon: string;
  };
};

export type SocialRewardCreateDataDictionaryType = {
  [key: string]: SocialRewardCreateDataType;
};

export const SocialRewardCreateDataDictionary: SocialRewardCreateDataDictionaryType = {
  [ESocialRewards.FACEBOOK_SHARE]: {
    pageTitle: 'Share my website on Facebook',
    labelName:
      'How many Coins should members get after<br/> sharing my website on Facebook?',
    campaignSettings: {
      icon: 'LinkIcon',
      title: 'URL SETTINGS',
      inputProps: {
        label: 'URL to share',
        placeholder: 'www.website.com'
      }
    },
    campaignOverview: {
      title: 'Share on Facebook',
      description: 'Reward members when they share your Facebook store.',
      fields: [
        { label: 'www.website.com', icon: 'LinkIcon' },
        { label: '0 Coins per user', icon: 'CoinsIcon' }
      ],
      icon: 'FacebookShareIcon'
    }
  },
  [ESocialRewards.FACEBOOK_LIKE]: {
    pageTitle: 'Like my page on Facebook',
    labelName:
      'How many Coins should members get after<br/> liking my page on Facebook?',
    campaignSettings: {
      icon: 'FacebookIcon',
      title: 'Social page settings',
      inputProps: {
        label: 'Facebook page URL',
        placeholder: 'www.facebook.com/yourstore'
      }
    },
    campaignOverview: {
      title: 'Like on Facebook',
      description: 'Reward people when they like your Facebook page.',
      fields: [
        { label: 'www.facebook.com/yourstore', icon: 'LinkIcon' },
        { label: '0 Coins per user', icon: 'CoinsIcon' }
      ],
      icon: 'FacebookFollowIcon'
    }
  },
  [ESocialRewards.INSTAGRAM_FOLLOW]: {
    pageTitle: 'Follow my page on Instagram',
    labelName:
      'How many Coins should members get after<br/> following my page on Instagram?',
    campaignSettings: {
      icon: 'InstagramIcon',
      title: 'Social page settings',
      inputProps: {
        label: 'Instagram username',
        placeholder: 'Your username'
      }
    },
    campaignOverview: {
      title: 'Follow on Instagram',
      description: 'Reward members when they follow you on Insta.',
      fields: [
        { label: 'Your username', icon: 'AtSignIcon' },
        { label: '0 Coins per user', icon: 'CoinsIcon' }
      ],
      icon: 'InstagramFollowIcon'
    }
  },
  [ESocialRewards.TWITTER_FOLLOW]: {
    pageTitle: 'Follow my page on Twitter',
    labelName:
      'How many Coins should members get after<br/> following my page on Twitter?',
    campaignSettings: {
      icon: 'TwitterIcon',
      title: 'Social page settings',
      inputProps: {
        label: 'Twitter username',
        placeholder: 'Your username'
      }
    },
    campaignOverview: {
      title: 'Follow on Twitter',
      description: 'Reward members when they follow your Twitter account.',
      fields: [
        { label: 'Your username', icon: 'AtSignIcon' },
        { label: '0 Coins per user', icon: 'CoinsIcon' }
      ],
      icon: 'TwitterFollowIcon'
    }
  },
  [ESocialRewards.TWITTER_SHARE]: {
    pageTitle: 'Share my website on Twitter',
    labelName:
      'How many Coins should members get after<br/> sharing my website on Twitter?',
    campaignSettings: {
      icon: 'LinkIcon',
      title: 'URL SETTINGS',
      inputProps: {
        label: 'URL to share',
        placeholder: 'www.website.com'
      },
      showExtraInput: true,
      extraInputProps: {
        label: 'Message',
        placeholder: 'e. g. It’s my favorite store!'
      }
    },
    campaignOverview: {
      title: 'Share on Twitter',
      description: 'Reward members when they share your store on Twitter.',
      fields: [
        { label: 'www.website.com', icon: 'LinkIcon' },
        { label: 'Your message', icon: 'ChatIcon' },
        { label: '0 Coins per user', icon: 'CoinsIcon' }
      ],
      icon: 'TwitterShareIcon'
    }
  },
  [ESocialRewards.YOUTUBE_SUBSCRIBE]: {
    pageTitle: 'Subscribe my channel on YouTube',
    labelName:
      'How many Coins should members get after<br/> subscribing to my Youtube channel?',
    campaignSettings: {
      icon: 'YouTubeIcon',
      title: 'SOCIAL PAGE SETTINGS',
      inputProps: {
        label: 'YouTube page URL',
        placeholder: 'www.youtube.com/yourstore'
      }
    },
    campaignOverview: {
      title: 'Subscribe on YouTube',
      description: 'Reward members when they subscribe to your channel.',
      fields: [
        { label: 'www.youtube.com/yourstore', icon: 'LinkIcon' },
        { label: '0 Coins per user', icon: 'CoinsIcon' }
      ],
      icon: 'YouTubeSubscribeIcon'
    }
  },
  [ESocialRewards.TIKTOK_FOLLOW]: {
    pageTitle: 'Follow my page on TikTok',
    labelName:
      'How many Coins should members get after<br/> following my page on TikTok?',
    campaignSettings: {
      icon: 'TikTokIcon',
      title: 'SOCIAL PAGE SETTINGS',
      inputProps: {
        label: 'TikTok page URL',
        placeholder: 'www.tiktok.com/@yourstore'
      }
    },
    campaignOverview: {
      title: 'Follow on TikTok',
      description: 'Reward members when they follow you on TikTok.',
      fields: [
        { label: 'www.tiktok.com/@yourstore', icon: 'LinkIcon' },
        { label: '0 Coins per user', icon: 'CoinsIcon' }
      ],
      icon: 'TikTokFollowIcon'
    }
  },
  [ESocialRewards.PINTEREST_FOLLOW]: {
    pageTitle: 'Follow my page on Pinterest',
    labelName:
      'How many Coins should members get after<br/> following my page on Pinterest?',
    campaignSettings: {
      icon: 'PinterestIcon',
      title: 'SOCIAL PAGE SETTINGS',
      inputProps: {
        label: 'Pinterest page URL',
        placeholder: 'co.pinterest.com/yourstore'
      }
    },
    campaignOverview: {
      title: 'Follow on Pinterest',
      description: 'Reward members when they follow you on Pinterest.',
      fields: [
        { label: 'co.pinterest.com/yourstore', icon: 'LinkIcon' },
        { label: '0 Coins per user', icon: 'CoinsIcon' }
      ],
      icon: 'PinterestFollowIcon'
    }
  }
};
